export default "__VITE_ASSET__CQDCq6Jx__"